import { mergeMap, switchMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { DetailsSidebarAction } from '@cbridge-packages/details-sidebar';
import { IClientApiDependencySegment, catchApiError } from '@cbridge-packages/api';
import { createApiErrorNotification } from '@cbridge-packages/notification';
import { PriceFilteringAction } from '../priceFiltering.action';

type IDependencies = IClientApiDependencySegment;

export const createPriceFilteringProfileEpic: IEpic<{}, IDependencies> = (action$, _, dependencies) => action$.pipe(
  isTypeOfAndGetPayload(PriceFilteringAction.create.started),
  switchMap((params) => {
    const { reject } = params;

    return dependencies.api
      .createPriceFilteringProfile({
        name: params.name,
        maxClientMarketDepth: params.maxClientMarketDepth,
        maxBookbMarketDepth: params.maxBookbMarketDepth,
      })
      .pipe(
        mergeMap((result) => {
          return [PriceFilteringAction.create.done({ params, result: { priceFilteringId: result.id } }), DetailsSidebarAction.close()];
        }),
        catchApiError((error) => {
          const isHandled = reject?.(error.errorCode, error.description, error.params);
          return [
            PriceFilteringAction.create.failed({ params, error }),
            ...(isHandled ? [] : [createApiErrorNotification(error)]),
          ];
        }),
      );
  }),
);
